import { init } from './form';
import { dataSuervey1, dataSuervey2 } from './model';

document.addEventListener('DOMContentLoaded', () => {
  // if(!redirectToMain())

  init(2, dataSuervey2);
});


function redirectToMain() {
  if (!location.hostname.match(/rc-/) && new Date() > new Date('2023-02-20:11:00')) {
    document.location.href = '/';
    return true;
  }
  return false;
}
